















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  LanguageDto,
  ActivityDto,
  ActivityStatisticsDto
} from "@/server/app.dtos";
import { GetActivityStatisticsDtoQuery } from "@/server/app.queries";
import { ActivitiesService } from "@/services/api/activities.service";

@Component
export default class ActivityDetailDashboardPage extends Vue {
  @Prop() activity!: ActivityDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  isLoading: boolean = false;
  activitiesService: ActivitiesService = new ActivitiesService();
  statistics: ActivityStatisticsDto | null = null;

  async created() {
    await this.Load();
  }

  async Load() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    const request = new GetActivityStatisticsDtoQuery();
    request.idActivity = this.activity.idActivity;
    await this.activitiesService
      .GetStatistics(request)
      .then((result: ActivityStatisticsDto) => (this.statistics = result))
      .finally(() => (this.isLoading = false));
  }
}
